import React from "react";
import { KeyboardArrowUp } from "@mui/icons-material";

const ScrollToTopButton = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-24 right-7 md:bottom-32 md:right-14 z-50 w-12 h-12 bg-primary_blue/30 text-white rounded-full shadow-lg hover:bg-primary_blue transition-all duration-300 transform hover:scale-110 focus:outline-none focus:ring-2 md:focus:ring-4 focus:ring-blue-400 focus:ring-opacity-50 flex items-center justify-center"
      aria-label="Scroll to top"
    >
      <KeyboardArrowUp className="text-xl md:text-2xl" />
    </button>
  );
};

export default ScrollToTopButton;
